import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

// services
import { recoverMarcaDeleted } from '../../Services/marcaService'

// Sweet alert
import Swal from 'sweetalert2'

// router
import { withRouter } from 'react-router-dom'

const ItemMarcaEliminada = ({ marca, setIsLoad }) => {
    const recoverMarcaSubmit = (marca) => {
        Swal.fire({
            title: 'Estas seguro de recuperarla?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Recuperar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                // consulta a la api para eliminar
                recoverMarcaDeleted(marca.id)
                    .then((res) => {
                        Swal.fire(
                            'Recuperado!',
                            'La marca fue recuperada.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    return (
        <tr>
            <th scope="row">{marca.id}</th>
            <td>{marca.nombre}</td>
            <td>% {marca.ganancia || 0}</td>
            <td>
                <button
                    className="btn text-warning"
                    onClick={() => {
                        recoverMarcaSubmit(marca)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Recuperar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemMarcaEliminada)
